import { InjectionToken } from '@angular/core';
import { WorkSchedulesPort } from './work-schedules.port';

export const WORK_SCHEDULES_PORT = new InjectionToken<WorkSchedulesPort>('WORK_SCHEDULES_PORT');